module.exports = __webpack_public_path__ + "img/swiper_5.a461d817.png";